const systemRouter = [
  {  
    path: 'home0000',
    name: 'home0000',
    component: () => import('@/views/hycot/Z/home0000.vue'),
    meta: { menu_code: 'home0000', menu_id: 'home0000', title: 'Home', affix: true }
  }
]

export default systemRouter